var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C3.34 8.5 2 9.84 2 11.5V19.5C2 21.16 3.34 22.5 5 22.5H6.5C7.6 22.5 8.5 21.6 8.5 20.5V10.5C8.5 9.4 7.6 8.5 6.5 8.5H5ZM6 17.5C6 17.91 5.66 18.25 5.25 18.25C4.84 18.25 4.5 17.91 4.5 17.5V13.5C4.5 13.09 4.84 12.75 5.25 12.75C5.66 12.75 6 13.09 6 13.5V17.5Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.5H13C11.34 2.5 10 3.84 10 5.5V19.5C10 21.16 11.34 22.5 13 22.5H13.5C13.78 22.5 14 22.28 14 22V18.5C14 17.95 14.45 17.5 15 17.5H17C17.55 17.5 18 17.95 18 18.5V22C18 22.28 18.22 22.5 18.5 22.5H19C20.66 22.5 22 21.16 22 19.5V5.5C22 3.84 20.66 2.5 19 2.5ZM14.75 13.5C14.75 13.91 14.41 14.25 14 14.25C13.59 14.25 13.25 13.91 13.25 13.5V8.5C13.25 8.09 13.59 7.75 14 7.75C14.41 7.75 14.75 8.09 14.75 8.5V13.5ZM18.75 13.5C18.75 13.91 18.41 14.25 18 14.25C17.59 14.25 17.25 13.91 17.25 13.5V8.5C17.25 8.09 17.59 7.75 18 7.75C18.41 7.75 18.75 8.09 18.75 8.5V13.5Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/Buildings.021d095077f6fa82583882c70cc17ba8.svg";
export { ForwardRef as ReactComponent };